import Vue from "vue";
import publicApi from "@/api/public";

//获取用户权限下的接口
export async function getUserSystem() {
  await getCurrentAccount();
}

//当前用户有权限的平台
export async function getCurrentAccount() {
  const resData = await publicApi.currentAccount();
  if (resData && resData.length > 0) {
    let firstCode = resData[0].code;
    window.location.href = "/" + firstCode.toLowerCase() + "/login";
  } else {
    Vue.prototype.$message({
      messgae: "没有菜单权限",
      type: "error",
    });
    localStorage.clear();
  }
}
